import { TextEditor, type TextEditorProps, classNames } from '@movingimage-evp/mi-ui-component-library';

import { slateToHtml } from '../../utils';

import styles from './rich-text.module.css';

type Props = {
  /** Stored rich-text content: legacy Slate JSON or HTML. */
  value?: string | null;
} & Omit<TextEditorProps, 'value' | 'readOnly' | 'minHeight'>;

/**
 * Read-only renderer for stored rich-text content. Renders the CL `TextEditor` in `readOnly` mode so
 * display matches the editing widget exactly; `slateToHtml` adapts legacy Slate JSON to the HTML the
 * editor consumes. The module CSS strips the editor-field chrome (elevated background, padding,
 * min-height) and re-maps typography/colours to the viewer theme so content renders inline.
 */
export function RichTextContent({ value, className, ...props }: Props) {
  return (
    <TextEditor
      {...props}
      readOnly
      minHeight={0}
      value={slateToHtml(value)}
      className={classNames(styles.richText, className)}
    />
  );
}
